<template>
  <div style="height: 100%">
    <label style="padding: 20px 0 10px 30px;">
      <b-icon icon="circle" style="margin-right: 5px;"></b-icon>
      环境设备</label>
    <!--    <el-carousel :arrow="tempHumidityData.length>1?'always':'never'" :interval="500" :autoplay="false"-->
    <!--                 indicator-position="none"-->
    <!--                 style="height: 80%">-->
    <!--      <el-carousel-item :key="item.spaceId" v-for="item in tempHumidityData">-->
    <el-carousel :interval="10000" indicator-position="none" :autoplay="true" style="height: 80%;z-index: 0"
                 @change="getData">
      <el-carousel-item :key="item.spaceId" v-for="item in spaceList">
        <el-row style="text-align: center">
          <label @touchstart="skipOverview(item)"  @click="skipOverview(item)"
                 class="pointer"
                 style="line-height: 3.5vh;color: #fff;"> {{ item.cnName }} </label>
        </el-row>
        <!--温湿度-->
        <el-row>
          <el-col :span="12">
            <el-col :span="12" style="height:7vh;text-align: right;padding-right: 8px;margin-top: 0.8vh;">
              <img src="../../assets/images/index/temperature_1.png" alt="" style="height: 100%">
            </el-col>
            <el-col :span="12">
              <div class="temperature" style="color: #32CFD2;font-size: 1.7rem;">
                {{ tempHumidityData[0].tempAvg === 0 ? '-' : tempHumidityData[0].tempAvg }}℃
              </div>
              <div style="font-size: 0.8rem">温度</div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="5" style="height:7vh;text-align: left;margin-top: 1.3vh;"><img
              src="../../assets/images/index/humidity_1.png" alt="" style="height: 100%"></el-col>
            <el-col :span="12">
              <div class="humidity" style="color: #32CFD2;font-size: 1.7rem;">
                {{ tempHumidityData[0].humiAvg === 0 ? '-' : tempHumidityData[0].humiAvg }}%
              </div>
              <div style="font-size: 0.8rem">湿度</div>
            </el-col>
          </el-col>
        </el-row>

        <!--温湿度趋势-->
        <el-row style="height: 42%">
          <label style="font-weight: bold;margin: 1vh 35px;">温湿度趋势</label>
          <line-chart :data="tempHumidityData[0].tempHumidityTrendData" :extendData="extendData" ref="lineChart"
                      v-if="tempHumidityData[0].tempHumidityTrendData"
                      style="height: 100%;"></line-chart>
          <no-data v-else></no-data>
        </el-row>

      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import LineChart from "@/components/echarts/LineChart";
import {getTemperatureAndHumidity} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";
import {getSpacelistByTemperatureAndHumidity} from "@/network/device-info";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "RoomEnvironmentDevice",
  mixins: [platenLayoutEdit],
  components: {LineChart, NoData},
  data() {
    return {
      tempHumidityData: [
        {
          "tempAvg": 0,
          "humiAvg": 0,
        }
      ],
      extendData: null,
      spaceList: [],
      deviceInfo: {}
    };
  },
  mounted() {
    this.getSpaceList();
  },
  methods: {
    getSpaceList() {
      getSpacelistByTemperatureAndHumidity().then(res => {
        if (res.code === 0) {
          this.spaceList = res.data
          if (this.spaceList.length > 0) {
            this.getData(0)
          }
        }
      })
    },
    getData(active) {
      getTemperatureAndHumidity(this.spaceList[active].id).then(res => {
        if (res.code === 0) {
          this.tempHumidityData = res.data.map(item => {
            const tempHumidityTrendData = {};
            tempHumidityTrendData.humidity = item.humidity;
            tempHumidityTrendData.temperature = item.temperature;
            tempHumidityTrendData.time = item.time;
            item.tempHumidityTrendData = tempHumidityTrendData;
            return item;
          })
        }
      })
    },
    skipOverview(spaceInfo) {
      if (this.isPlatenLayoutEditing) return
      this.deviceInfo.spaceId = spaceInfo.id;
      this.deviceInfo.spaceName = spaceInfo.cnName
      this.$emit('skipOverview', this.deviceInfo, 'environment_category_tag')
    },
    changeSpace() {

    }
  }
}
</script>

<style scoped>

label {
  font-weight: bold;
  color: #01EFFD;
}

.el-carousel >>> .el-carousel__arrow {
  top: 5%;
}
</style>
